
  <section class="cmn-innerpage-wrapper holiday">
    <div class="head"> 
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search"
          (input)="onSearch($event)"
        />
      </div>
      <button class="cmn-upload-btn" (click)="openDialog()" *ngIf="canUploadHoliday$ | async">
        <img src="assets/images/icons/icon-upload.svg" alt="Upload Icon" />
        <span>Upload</span>
      </button>
      <button class="cmn-add-btn"  (click)="openAddDialog()" *ngIf="canCreateHoliday$ | async">
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
        Holiday
      </button>
    </div>
    <div class="inner-content">
      <ag-grid-angular
        style="width: 100%;"
        class="ag-theme-quartz"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [rowSelection]="rowSelection"
        [animateRows]="true"
      ></ag-grid-angular>
    </div>
  </section>

